import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const parseNumericValue = (value, fallback) => {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const SpinnerCircular = ({
  size = 32,
  thickness = 180,
  speed = 100,
  color = '#3f51b5',
  secondaryColor = 'rgba(0, 0, 0, 0.15)',
  className
}) => {
  const normalizedSize = Math.max(12, parseNumericValue(size, 32));
  const normalizedThickness = Math.max(30, parseNumericValue(thickness, 180));
  const normalizedSpeed = Math.max(1, parseNumericValue(speed, 100));
  const strokeWidth = Math.max(2, (normalizedSize * normalizedThickness) / 1000);
  const duration = Math.max(0.25, 100 / normalizedSpeed);

  return (
    <Spinner
      aria-label="Cargando"
      className={className}
      role="status"
      $color={color}
      $duration={duration}
      $secondaryColor={secondaryColor}
      $size={normalizedSize}
      $strokeWidth={strokeWidth}
    />
  );
};

SpinnerCircular.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  secondaryColor: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  speed: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  thickness: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default SpinnerCircular;

const Spinner = styled.span`
  animation: ${spin} ${({ $duration }) => `${$duration}s`} linear infinite;
  border: ${({ $strokeWidth }) => `${$strokeWidth}px`} solid ${({ $secondaryColor }) => $secondaryColor};
  border-radius: 50%;
  border-top-color: ${({ $color }) => $color};
  box-sizing: border-box;
  display: inline-block;
  height: ${({ $size }) => `${$size}px`};
  width: ${({ $size }) => `${$size}px`};
`;
